import React, { useState, useEffect } from 'react'
import {
  Box,
  Tabs,
  Tab,
  Paper,
  Snackbar,
  Alert,
} from '@mui/material'
import {
  Schedule as ScheduleIcon,
  Inventory as InventoryIcon,
} from '@mui/icons-material'
import CardTitle from 'src/components/sharedComponents/CardTitle'
import { getRolUser } from '@auteco/services/motosSnopServices'
import MaestroContainer from './MaestroContainer'
import CalendarioContainer from './CalendarioContainer'

const LeadtimeContainer = () => {
  const [infoBars, setInfoBars] = useState({})
  const [activeTab, setActiveTab] = useState(0)
  const [showAlert, setShowAlert] = useState(false)
  const [alertMessage, setAlertMessage] = useState('')

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue)
  }

  const handleAlert = (message) => {
    setAlertMessage(message)
    setShowAlert(true)
  }

  const getInfoBars = async () => {
    const response = await getRolUser()
    if (response) {
      setInfoBars(response.iam.nombre)
    }
  }

  const handleCloseAlert = () => {
    setShowAlert(false)
  }

  useEffect(() => {
    getInfoBars()
  }, [])

  console.log(infoBars)

  if (infoBars !== 'Comprador') {
    return (
      <div>
        <p>No tienes permisos para acceder a esta página</p>
      </div>
    )
  }

  return (
    <Box sx={{ padding: 3 }}>
      <CardTitle title="Leadtime" />

      <Paper elevation={1} sx={{ borderRadius: 2, overflow: 'hidden' }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          sx={{
            backgroundColor: '#f8f9fa',
            '& .MuiTab-root': {
              fontWeight: 'bold',
              color: '#666',
            },
            '& .Mui-selected': {
              color: '#4c75aa !important',
            },
            '& .MuiTabs-indicator': {
              backgroundColor: '#4c75aa',
            },
          }}
        >
          <Tab
            label="Maestro Leadtime"
            icon={<InventoryIcon />}
            iconPosition="start"
            sx={{ textTransform: 'none' }}
          />
          <Tab
            label="Calendario"
            icon={<ScheduleIcon />}
            iconPosition="start"
            sx={{ textTransform: 'none' }}
          />
        </Tabs>

        <Box sx={{ padding: 3 }}>
          {activeTab === 0 && (
            <MaestroContainer onAlert={handleAlert} />
          )}

          {activeTab === 1 && (
            <CalendarioContainer onAlert={handleAlert} />
          )}
        </Box>
      </Paper>

      <Snackbar
        open={showAlert}
        autoHideDuration={3000}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleCloseAlert} severity="success" sx={{ width: '100%' }}>
          {alertMessage}
        </Alert>
      </Snackbar>
    </Box>
  )
}

export default LeadtimeContainer 